const ModalWhats = function () {

    const modal = function () {
        var modalSearch = $("#modal-whats");
        modalSearch.fadeToggle(200);
    }

    const closeModal = function (el) {
        if (el.attr('data-modal') == "modal") {
            el.closest('.elm-modal').fadeOut(100);
        } else {
            modal();
        }
    }

    return {
        init: function () {

            $(document).on("click", "#fale-bt-link", function () {
                modal()
            });

            $(document).on("click", ".s-close-whats", function () {
                closeModal($(this));
            });
        }
    }

}();

module.exports = ModalWhats;